import * as React from 'react';
import { connect, Dispatch } from "react-redux";
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from "react-router"
import { IApplicationState, AppActionCreators, EmailTemplateActionCreators } from "@nkr/store/index";
import { IEmailEntityType } from '@nkr/models/index';

interface ISendPreview {
    data: {
        success: boolean
    }
}

interface IRouterProps {
    id?: string
}

interface IOwnProps extends RouteComponentProps<IRouterProps> { }

interface IEmailTemplatePreviewStateProps {
    entityTypes: IEmailEntityType[],
    emailAddress: string
}
interface IEmailTemplatePreviewDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getPreview: (emailTemplateId: number) => Promise<any>,
    sendPreview: (emailTemplateId: number, emailAddress: string, entityTypeId: number) => Promise<any>
}

type TEmailTemplatePreviewProps =
    IOwnProps
    & IEmailTemplatePreviewStateProps
    & IEmailTemplatePreviewDispatchProps;

interface IState {
    entityTypes: IEmailEntityType[],
    selectedEntityTypeId: number,
    emailAddress: string,
    emailTemplateId: number,
    entityText: string,
    description: string,
    //showSendPreviewWarning: boolean,
    modalMessage: string,
    message: {
        show: boolean,
        type: string,
        text: string
    }
}

class EmailTemplatePreview extends React.Component<TEmailTemplatePreviewProps, IState, IEmailTemplatePreviewDispatchProps>{
    constructor(props: TEmailTemplatePreviewProps) {
        super(props);

        this.state = {
            entityTypes: [],
            emailAddress: "",
            emailTemplateId: 0,
            selectedEntityTypeId: 0,
            entityText: "",
            description: "",
            //showSendPreviewWarning: false,
            modalMessage: "",
            message: {
                show: false,
                type: "",
                text: ""
            }
        };
    }

    componentDidMount() {
        this.getData();
    }

    public getData = () => {
        var emailTemplateId = this.props.match.params.id != null ? parseInt(this.props.match.params.id) : 0;

        this.props.getPreview(emailTemplateId).then(() => {
            this.setState({
                emailAddress: this.props.emailAddress,
                entityTypes: this.props.entityTypes,
                emailTemplateId: emailTemplateId,
                description: this.props.entityTypes.length > 0 ? this.props.entityTypes[0].description : "",
                selectedEntityTypeId: this.props.entityTypes[0].id
            });
        });
    }

    public onChangeEntityType = (el: any) => {
        var selectedEntityTypeId = el.target.value;

        this.setState({ selectedEntityTypeId });
    }

    public onChangeEntityText = (el: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            entityText: el.currentTarget.value
        });
    }

    public onChangeEmailAddress = (el: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            emailAddress: el.currentTarget.value
        });
    }

    public onClickSendPreview = () => {
        var emailTemplateId = this.props.match.params.id != null ? parseInt(this.props.match.params.id) : 0;
        var emailAddress = this.state.emailAddress;
        var entityText = this.state.entityText;
        var entityId: number = 0;

        if (this.state.entityText.length > 0) {
            if (!this.isInt(entityText)) {
                //this.setState({ showSendPreviewWarning: true, modalMessage: "Entity ID field must be numeric or left empty." });
                this.setState({
                    message: {
                        show: true,
                        type: "danger",
                        text: "Entity ID field must be numeric or left empty."
                    }
                });

                return;
            } else {
                entityId = parseInt(entityText);
            }
        }

        this.props.sendPreview(emailTemplateId, emailAddress, entityId).then((response: ISendPreview) => {
            let message = response.data.success ? "Email has been sent to email engine." : "There was an error sending the email to email engine.";
            let type = response.data.success ? "success" : "danger";

            //if (response.data.success) {
            //    this.setState({ showSendPreviewWarning: true, modalMessage: "Email has been sent to email engine." });
            //} else {
            //    this.setState({ showSendPreviewWarning: true, modalMessage: "There was an error sending the email to email engine." });
            //}

            this.setState({
                message: {
                    show: true,
                    type,
                    text: message
                }
            });
        });
    }

    onClickToEdit = () => {
        window.location.href = "/email-template/" + this.state.emailTemplateId;
    }

    onClickReturnToList = () => {
        window.location.href = "/email-engine";
    }

    //public onModalHide = (el: any) => {
    //    this.setState({ showSendPreviewWarning: false });
    //}

    public isInt(value: any) {
        var x = parseFloat(value);
        return !isNaN(value) && (x | 0) === x;
    }

    public render() {
        // let entityElement;

        // if (this.state.entityTypes.length > 1) {
        //     entityElement =
        //         <select id="entityElement" className="form-control" name="EntityType" onChange={this.onChangeEntityType}>
        //             <option value="0">Select</option>
        //             {this.state.entityTypes.map(entityType =>
        //                 <option value={entityType.id} selected={this.state.selectedEntityTypeId == entityType.id}>{entityType.description}</option>
        //             )};
        //         </select>;
        // }
        // else {
        //     entityElement = <input id="entityElement" type="text" className="form-control" name="EntityType" value={this.state.description} placeholder="Default" ></input>;
        // }

        return (
            <div className="container">
                <div className="row" style={{ borderBottom: 1, borderBottomStyle: "solid", borderBottomColor: "#ddd", marginBottom: 20 }}>
                    <div className="col-xs-12">
                        <h3>Preview Template {this.state.emailTemplateId}</h3>
                    </div>
                </div>

                {this.state.message.show ?
                    <div className="row">
                        <div className="col-xs-12">
                            <div className={"alert alert-" + this.state.message.type}>
                                {this.state.message.text}
                            </div>
                        </div>
                    </div>
                    : null}

                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="form-group">
                            <label className="control-label" htmlFor="entityElement">Entity Type:</label>
                            {this.state.entityTypes.length > 1 ?
                                <select id="entityElement" className="form-control" name="EntityType" value={this.state.selectedEntityTypeId} onChange={this.onChangeEntityType}>
                                    <option value="0">Select</option>
                                    {this.state.entityTypes.map(entityType =>
                                        <option value={entityType.id}>{entityType.description}</option>
                                    )};
                                </select>
                                :
                                <input id="entityElement" type="text" className="form-control" name="EntityType" value={this.state.selectedEntityTypeId} placeholder="Default" />
                            }
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="form-group">
                            <label className="control-label" htmlFor="entityId">Entity Id:</label>
                            <input id="entityId" type="text" className="form-control" name="EntityId" value={this.state.entityText} placeholder="Default" onChange={this.onChangeEntityText} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="form-group">
                            <label className="control-label" htmlFor="emailAddress">Destination email address:</label>
                            <input id="emailAddress" type="text" className="form-control" name="TesterEmailAddress" value={this.props.emailAddress} onChange={this.onChangeEmailAddress} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-xs-12 col-sm-12">
                        <label className="control-label" htmlFor="SendPreviewNow" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5 }}><input type="checkbox" id="SendPreviewNow" name="SendPreviewNow" /></div>
                            <div>Send preview now (If this box is not checked the preview will be sent when the email service is running.)</div>
                        </label>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-xs-12 col-sm-2" style={{ display: "flex" }}>
                        <button className="btn btn-danger" style={{ marginRight: 5 }} onClick={this.onClickSendPreview}>Send Preview</button>
                        <button className="btn btn-link" onClick={this.onClickToEdit}>Edit This Template</button>
                        <button className="btn btn-link" onClick={this.onClickReturnToList}>Return to Template List</button>
                    </div>
                </div>

                {/*<Modal bsSize="lg" show={this.state.showSendPreviewWarning} onHide={this.onModalHide}>
                    <Modal.Header>
                        <Modal.Title>Validation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalMessage}
                    </Modal.Body>
                    <Modal.Footer >
                        <button className="btn btn-primary" onClick={this.onModalHide}>Ok</button>
                    </Modal.Footer>
                </Modal>*/}
            </div>
        );
    }
}

const mapAppStateToProps = (appState: IApplicationState): IEmailTemplatePreviewStateProps => {
    return {
        emailAddress: appState.emailTemplates.emailPreview.emailAddress,
        entityTypes: appState.emailTemplates.emailPreview.entityTypes
    };
};

const mapDisptachToProps = (dispatch: Dispatch<any>): IEmailTemplatePreviewDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getPreview: (emailTemplateId) => { return dispatch(EmailTemplateActionCreators.getPreview(emailTemplateId)); },
        sendPreview: (emailTemplateId, emailAddress, entityTypeId) => { return dispatch(EmailTemplateActionCreators.sendPreview(emailTemplateId, emailAddress, entityTypeId)); }
    };
};

export default withRouter(connect<IEmailTemplatePreviewStateProps, IEmailTemplatePreviewDispatchProps, IOwnProps>(
    mapAppStateToProps,
    mapDisptachToProps)(EmailTemplatePreview));